
import { mapActions, mapGetters } from 'vuex';
import HomeIcon from '~/components/ui/icons/HomeIcon.vue';
import ProfileIcon from '~/components/ui/icons/ProfileIcon.vue';
import PortfolioIcon from '~/components/ui/icons/PortfolioIcon.vue';
import MarketIcon from '~/components/ui/icons/MarketIcon.vue';
import BookmarkIcon from '~/components/ui/icons/BookmarkIcon.vue';
import MoreIcon from '~/components/ui/icons/MoreIcon.vue';
import AlertIcon from '~/components/ui/icons/AlertIcon.vue';
import TrophyIcon from '~/components/ui/icons/TrophyIcon.vue';
import {
  tosUrl,
  aboutUsUrl,
  legalNoticeUrl,
  privacyPolicyUrl,
} from '~/utils/links';
import { copyrightText } from '~/utils/behavior/copyright';
import Link from '~/components/ui/atom/Link.vue';
import MessageIcon from '~/components/ui/icons/MessageIcon.vue';
import SettingsIcon from '~/components/ui/icons/SettingsIcon.vue';
import SupportIcon from '~/components/ui/icons/SupportIcon.vue';
import LogoutIcon from '~/components/ui/icons/LogoutIcon.vue';
import LearnIcon from '~/components/ui/icons/LearnIcon.vue';
import { logout } from '~/utils/behavior/authService';
import { appURLs, inAppRedirect } from '@/utils/route-redirects';
import { isMobileResponsive } from '@/utils/mixins';
import { capitalizeFirstLetter } from '@/utils/string-formatter';
import { eventManager } from '@/utils/behavior/applicationEvents/event-manager';

export default {
  name: 'Sidebar',
  components: {
    HomeIcon,
    ProfileIcon,
    PortfolioIcon,
    MarketIcon,
    BookmarkIcon,
    MoreIcon,
    AlertIcon,
    TrophyIcon,
    Link,
    MessageIcon,
    SettingsIcon,
    SupportIcon,
    LogoutIcon,
    LearnIcon,
  },
  mixins: [isMobileResponsive],
  data() {
    return {
      showMoreMenu: false,
      tosUrl,
      aboutUsUrl,
      legalNoticeUrl,
      privacyPolicyUrl,
      copyrightText,
    };
  },
  computed: {
    ...mapGetters('authentication', [
      'profile',
      'profileId',
      'isEmailConfirmed',
    ]),
    ...mapGetters('modals', ['helpCenterObjectRes']),
    ...mapGetters('messaging', ['messageNotificationCount']),
    sanitizedNotificationCount() {
      return this.messageNotificationCount ?? 0;
    },
    appURLs() {
      return appURLs;
    },
    profilePicAlt() {
      return this.$t('posession', {
        subj: this.profile.displayName,
        obj: this.$t('profile_picture'),
      });
    },
  },
  methods: {
    ...mapActions('modals', [
      'showCreatePostModal',
      'toggleLegalDisclaimerModal',
    ]),
    hideMoreMenu() {
      this.showMoreMenu = false;
    },
    async handleLogout() {
      this.raiseClickMenuPrincipalEvent('logout');
      await logout();
    },
    handleSupportRedirect() {
      this.raiseClickMenuPrincipalEvent('support');
      window.open(
        'https://skade.atlassian.net/servicedesk/customer/portal/1',
        '_blank'
      );
    },
    redirectToSettings() {
      this.raiseClickMenuPrincipalEvent('settings');
      inAppRedirect(appURLs.settings());
    },
    raiseClickMenuPrincipalEvent(value) {
      eventManager.raiseClickMenuPrincipalEvent({
        text: 'Sidebar | ' + capitalizeFirstLetter(value),
      });
    },
  },
};
